import $ from "jquery";

export function wrap(newNode, referenceNode) {
  referenceNode?.parentNode?.insertBefore(newNode, referenceNode);
  newNode.appendChild(referenceNode);
}

export function wrapAllChildrens(newNode, referenceNode) {
  return $(referenceNode).contents().wrapAll($(newNode));
}

export function wrapRichTextFields(html, newNode) {
  const doc = document.implementation.createHTMLDocument("");

  doc.body.innerHTML = html;

  var instances = doc.querySelectorAll(".grigora-richtext-input__field");

  instances.forEach((rtfield) => {
    wrapAllChildrens(newNode, rtfield);
  });

  return doc.body.innerHTML;
}
